import clsx from 'clsx';
import { useRouter } from 'next/router';
import React from 'react';

export type Props = {
  dateTime: Date | string | number;
  dateStyle?: Intl.DateTimeFormatOptions['dateStyle'];
  timeStyle?: Intl.DateTimeFormatOptions['timeStyle'];
  className?: string;
};

export default function DateTime({ dateTime, className, dateStyle, timeStyle }: Props) {
  const { locale } = useRouter();
  const formatter = new Intl.DateTimeFormat(locale, {
    dateStyle,
    timeStyle,
    hour12: true,
  });
  const date = new Date(dateTime);

  return (
    <time dateTime={date.toISOString()} className={clsx(className)}>
      {formatter.format(date)}
    </time>
  );
}
